import { withInstall } from '@lit-element/utils'

import Wheel from './src/wheel.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtWheel: SFCWithInstall<typeof Wheel> = withInstall(Wheel)
export default LtWheel

export * from './src/wheel'
